import {fetchBody, URL_CUSTOMERCONTRACT_GET_LIST, URL_CUSTOMERCONTRACT_ADD, URL_CUSTOMERCONTRACT_GET_DETAIL} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";

export function api_getCustomerContractList ({mReqCustomerContractList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqCustomerContractList, token}), 
      url: URL_CUSTOMERCONTRACT_GET_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_addCustomerContract ({mRespCustomerContract, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespCustomerContract, token}), 
      url: URL_CUSTOMERCONTRACT_ADD, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getCustomerContractDetail ({mReqCustomerContractDetail, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqCustomerContractDetail, token}), 
      url: URL_CUSTOMERCONTRACT_GET_DETAIL, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}
